var fn = function( obj ){
var __t,__p='';
__p+='\n#ifndef _H_DECODE_RGBE_\n#define _H_DECODE_RGBE_\n\nvec3 decodeRGBE( vec4 hdr ){\n  return hdr.rgb * exp2( (hdr.a*255.0)-128.0 );\n  // return hdr.rgb * pow( 2.0, (hdr.a*255.0)-128.0 );\n}\n\n#endif';
return __p;
};
fn.toString=fn;
module.exports = fn;